import styled from 'styled-components';
import colors from '../../../../styles/colors';
import Button from '../../../Button';

const StyledAudio = styled.audio`
  max-width: 100%;
  width: 600px;
`;

const ErrorText = styled.div`
  color: ${colors.base.warning};
  font-size: 12px;
  padding: 2px;
`;

const TranscriptionText = styled.div`
  width: 100%;
  margin-top: 10px;
  font-size: 12px;
  display: flex;
  flex-direction: column;
`;

const TranscriptionWrapper = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 10px;
  justify-content: flex-start;
`;

const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 10px;
  justify-content: flex-start;
`;

const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  .MuiCircularProgress-svg{
    color: ${colors.base.secondary2};
  }
`;

const StyledButton = styled(Button)`
  width: fit-content;
  height: 30px;
  font-size: 12px;
  font-weight: 400;
  color: ${colors.base.secondary2};
  padding: 14px;
  border-radius: 20px;
  background-color: ${colors.base.alpha};
  cursor: pointer;
  align-self: center;
`;

export {
  StyledAudio,
  TranscriptionText,
  TranscriptionWrapper,
  ButtonContainer,
  LoaderContainer,
  StyledButton,
  ErrorText,
};
